import { CAST_PILOT_ASSISTANT } from '@cast/constants';

// In-house standalone feature flag that steers the CastPilot Assistant acknowledgement UX
// (consent dialog + acknowledged notice + action item). Read directly via
// `useFlagsQuery` (like `useIsOpsPilotEnabled`) — intentionally NOT wired into
// ABILITY_CONFIG, since it gates UI state only, never feature access.
export const CAST_PILOT_ASSISTANT_ACK_FLAG =
  'ui__standalone--opspilot-acknowledgement';

// PostHog audit event emitted when a user acknowledges the disclaimer.
export const CAST_PILOT_ASSISTANT_ACK_EVENT_TITLE = `${CAST_PILOT_ASSISTANT} Disclaimer Acknowledged`;
export const CAST_PILOT_ASSISTANT_ACK_EVENT_TYPE = 'consent';

// PostHog events emitted whenever CastPilot Assistant is actually enabled / disabled.
export const CAST_PILOT_ASSISTANT_ENABLED_EVENT_TITLE = `${CAST_PILOT_ASSISTANT} Enabled`;
export const CAST_PILOT_ASSISTANT_DISABLED_EVENT_TITLE = `${CAST_PILOT_ASSISTANT} Disabled`;
export const CAST_PILOT_ASSISTANT_TOGGLE_EVENT_TYPE = 'feature_toggle';

// Bump when the legal-approved disclaimer copy / terms change.
export const CAST_PILOT_ASSISTANT_TERMS_VERSION = 'v1';

export const CAST_PILOT_ASSISTANT_TERMS_URL =
  'https://cast.ai/terms-of-service/';
export const CAST_PILOT_ASSISTANT_PRIVACY_URL =
  'https://cast.ai/privacy-policy/';

// PostHog property keys (organization group + person level) used for audit.
export const CAST_PILOT_ASSISTANT_PROP = {
  enabled: 'castpilot_assistant_enabled',
  acknowledgedAt: 'castpilot_assistant_acknowledged_at',
  acknowledgedBy: 'castpilot_assistant_acknowledged_by',
  termsVersion: 'castpilot_assistant_terms_version',
  userLastAcknowledgedAt: 'castpilot_assistant_last_acknowledged_at',
  userLastAcknowledgedOrg: 'castpilot_assistant_last_acknowledged_org',
} as const;
